'use client';

import type { FieldError } from '@icebreaker/shared/errors';
import {
  fieldErrorSentence,
  splitFieldErrorTexts,
  type FieldErrorText,
} from '@icebreaker/shared/i18n';
import { useTranslation } from './i18n-context';
import { useErrorMessage, type ErrorLike } from './state-views';

/**
 * ALAN BAZLI HATA — FORMUN GÖRÜNÜMÜ (elle test 3 · md. 5).
 *
 * BULGU: kullanıcı kurum formuna iletişim e-postası olarak `test` yazdı; ekran
 * "Girdiğin bilgilerde hata var. Lütfen kontrol et." dedi ve HANGİ ALAN
 * olduğunu söylemedi. Sunucu biliyordu (`fieldErrors`), sözlük cümleyi kurabiliyordu
 * (`field-error-text.ts`) — ama tüm web uygulamasında tek bir yüzey okuyordu.
 *
 * Bu kanca formun sözleşmesidir: form, cümleyi ALANIN ALTINA yazacağı yolları
 * bildirir; kanca geri kalanı genel uyarı bölgesine bırakır. Genel cümle
 * SUSTURULMAZ — yalnızca her alan hatası yerine oturduğunda gizlenir (md. 9:
 * eksik anlatma yok).
 */
export interface FormErrorView {
  /** Alanın altına yazılacak cümle; yoksa `undefined` (Field `error` propu). */
  readonly at: (path: string) => string | undefined;
  /** Genel uyarı bölgesi: kod cümlesi + alanla eşleşmeyen alan cümleleri. */
  readonly summary: readonly string[];
}

export function useFormErrors(
  error: (ErrorLike & { readonly fieldErrors?: readonly FieldError[] }) | null | undefined,
  inlinePaths: readonly string[],
): FormErrorView {
  const t = useTranslation();
  const errorMessage = useErrorMessage();
  const sentence = (item: FieldErrorText): string => fieldErrorSentence(t, item);

  if (!error) return { at: () => undefined, summary: [] };

  const split = splitFieldErrorTexts({ fieldErrors: [...(error.fieldErrors ?? [])] }, inlinePaths);
  const generic = split.fullyInline ? null : errorMessage(error);
  return {
    at: (path) => {
      const found = split.inline.get(path);
      return found ? sentence(found) : undefined;
    },
    summary: [...(generic === null ? [] : [generic]), ...split.rest.map(sentence)],
  };
}
